import { createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist'
import createWebStorageModule from 'redux-persist/lib/storage/createWebStorage'

const createWebStorage = createWebStorageModule.default || createWebStorageModule
const storage = createWebStorage('local') // localStorage for web

// Redux persist
const persistConfig = {
    key: 'root',
    storage,
  
    whitelist: [
       'user',  // El redux store de user se persiste
    ],
  }


export default (rootReducer) => {
    const persistedReducer = persistReducer(persistConfig, rootReducer)
    const store = createStore(persistedReducer);
    const persistor = persistStore(store)

    return { store, persistor }
}